/**
 * 批量添加创意
 */
import { Component, input, output } from '@angular/core';
import {
  BatchUploadConfig,
  BatchUploadModalComponent,
} from '@shared/components/batch-upload-modal/batch-upload-modal.component';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'app-batch-upload-creative',
  imports: [SharedModule, BatchUploadModalComponent],
  template: `
    <app-batch-upload-modal
      [isVisible]="isVisible()"
      [config]="uploadConfig"
      (isVisibleChange)="isVisibleChange.emit($event)"
      (nzOnOk)="nzOnOk()"
    ></app-batch-upload-modal>
  `,
})
export class BatchUploadCreativeComponent {
  // 输入属性
  readonly isVisible = input<boolean>(false);

  // 输出事件
  readonly isVisibleChange = output<boolean>();

  // 上传配置
  uploadConfig: BatchUploadConfig = {
    title: '批量添加创意',
    templateUrl:
      'https://static-cdn.linkworld.cn/xiaohong/红品智-推广-批量添加创意模板_2026-08-13.xlsx',
    type: 7,
    description: '1、下载批量添加创意模板，批量填写创意信息',
  };

  nzOnOk() {
    // 手动埋点 红品智-工具-批量添加创意
    (window as any)?.lwTrackEvent?.add({
      event_id: 250,
      event_code: 'spotlight-tools-uploadCreateCreativity',
      event_type: 'upload',
    });
  }
}
